export const auth = state => state.auth
export const outlets = state => state.auth.user.outlets
export const outlet = state => {
  return state.auth.user.outlets.find(outlet => outlet.id === state.auth.user.outlet)
}
export const activeOutletID = state => state.auth.user.outlet
export const externalToken = state => state.auth.externalApiKey



// WEBPACK FOOTER //
// ./src/store/getters.js